<div class="dialog-container" *ngIf="isCustomUiChange; else oldUIDesign">

    <!-- Header -->
    <div class="dialog-header header">
        <div class="title-section">
            <mat-icon>folder_open</mat-icon>
            <h2>Document Manager</h2>
        </div>

        <button mat-icon-button class="close-btn" [mat-dialog-close]="true">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Loader -->
    <div class="loader-wrapper" *ngIf="loadFile">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Loading documents...</p>
    </div>

    <!-- Content -->
    <div class="table-wrapper" *ngIf="!loadFile">

        <table mat-table [dataSource]="files" matSort class="documents-table">

            <!-- Document Type -->
            <ng-container matColumnDef="ImageCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Document Type
                </th>
                <td mat-cell *matCellDef="let file" class="doc-type-column">
                    <div class="doc-type">
                        <mat-icon>description</mat-icon>
                        {{ imageType(file.ImageCode) }}
                    </div>
                </td>
            </ng-container>

            <!-- Description -->
            <ng-container matColumnDef="Description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Description
                </th>
                <td mat-cell *matCellDef="let file" class="doc-type-column">
                    <!-- {{ file.Description || '-' }} -->

                    <!-- Display Mode -->
                    <div *ngIf="editingImageId !== file.ImageId" class="description-text" (dblclick)="startEdit(file)">
                        {{ file.Description || '-' }}
                        <mat-icon class="edit-icon">
                            edit
                        </mat-icon>
                    </div>

                    <!-- Edit Mode -->
                    <div *ngIf="editingImageId === file.ImageId" class="description-edit">
                        <input class="description-edit-input" [(ngModel)]="editedDescription">
                        <div class="edit-actions">
                            <button mat-icon-button color="warn" (click)="cancelEdit()">
                                <mat-icon>close</mat-icon>
                            </button>
                            <button mat-icon-button color="primary" (click)="updateDescription(file)">
                                <mat-icon>done</mat-icon>
                            </button>
                        </div>
                    </div>
                </td>
            </ng-container>

            <!-- File Name -->
            <ng-container matColumnDef="FileName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    File Name
                </th>
                <td mat-cell *matCellDef="let file" class="doc-type-column">
                    <span class="file-name">
                        {{ file.FileName }}
                    </span>
                </td>
            </ng-container>

            <!-- View -->
            <ng-container matColumnDef="View">
                <th mat-header-cell *matHeaderCellDef>
                    View
                </th>
                <td mat-cell *matCellDef="let file">
                    <button mat-mini-fab color="primary" matTooltip="View File" (click)="openFile(file)">
                        <mat-icon>visibility</mat-icon>
                    </button>
                </td>
            </ng-container>

            <!-- Delete -->
            <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef>
                    Delete
                </th>
                <td mat-cell *matCellDef="let file">
                    <button mat-mini-fab color="warn" matTooltip="Delete File" (click)="deleteFile(file)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
        </table>

        <div class="empty-state" *ngIf="files?.data?.length === 0">
            <mat-icon>folder_off</mat-icon>
            <p>No documents found</p>
        </div>
    </div>
</div>

<ng-template #oldUIDesign>
    <div style="float:right;top:-5px;right:-5px;color:white">
    <button mat-icon-button [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
    </button>  
</div>

<h1 mat-dialog-title class="header" style="padding:0.5vw;font-size:1.2vw; color:white">View/Delete File</h1>

<div mat-dialog-content>

    <mat-card style="width: 40vw;">
        <mat-card-content>
            <div id="loading" *ngIf="loadFile">
                <mat-spinner [diameter]="25" color="primary"></mat-spinner>
            </div>

            <table class="content-table" style="width:100%;" mat-table [dataSource]="files" matSort>
                <ng-container matColumnDef="ImageCode" style="width:20%;">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Image
                    </th>
                    <td mat-cell *matCellDef="let file">
                        {{ imageType(file.ImageCode) }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Description" style="width: 10%;">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Description
                    </th>
                    <td mat-cell *matCellDef="let file">
                        {{ file.Description }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="FileName" style="width:50%;">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        File Type
                    </th>
                    <td mat-cell *matCellDef="let file">
                        {{ file.FileName }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="View" style="width: 10%;">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;">
                        View
                    </th>
                    <td mat-cell *matCellDef="let file">
                        <button matTooltip="View" style="width: 100% !important;" mat-button (click)="openFile(file)">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Delete" style="width: 10%;">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;">
                        Delete
                    </th>
                    <td mat-cell *matCellDef="let file">
                        <button matTooltip="Delete" matTooltipPosition="right" style="width: 100% !important;" mat-button (click)="deleteFile(file)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


                <!-- <thead mat-header-cell style="width:100%;">
                    <th style="text-align: left;">File Type</th>
                    <th style="text-align: left;">Image</th>
                    <th>View</th>
                    <th>Delete</th>
                </thead>
                <tbody style="width:100%;">
                    <tr *ngFor="let file of files" style="width:100%;">
                        <td style="width:20%;">{{imageType(file.ImageCode)}}</td>
                        <td style="width:50%;">{{file.FileName}}</td>
                        <td style="width:15%;">
                            <button matTooltip="View" style="width: 100% !important;" mat-button (click)="openFile(file)">
                                <mat-icon>visibility</mat-icon>
                            </button>
                        </td>
                        <td style="width:15%;">
                            <button matTooltip="Delete" matTooltipPosition="right" style="width: 100% !important;" mat-button (click)="deleteFile(file)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                        
                    </tr>
                </tbody> -->
            </table>

            <!--
            <mat-list *ngIf="!loadFile">
                <mat-list-item *ngFor="let file of files">
                    <button matTooltip="Folder" style="width: 100% !important;" mat-button (click)="openFile(file)">{{file.FileName}}
                        <mat-icon>folder</mat-icon>
                    </button>
                    
                </mat-list-item>
            </mat-list>
            -->
        </mat-card-content>
    </mat-card>
</div>
</ng-template>